import Vue from 'vue';
import Router from 'vue-router';
import HelloWorld from '@/components/HelloWorld';
import login from '@/page/login/index';
import repayAgreement from '@/page/protocol/repayAgreement';
import repayBq from '@/page/protocol/repayBq';
import repayMmt from '@/page/protocol/repayMmt';
import tool from '@/js/tool.js';

Vue.use(Router);

const vueRouter = new Router({
	routes: [
		// {
		//   path: '/',
		//   name: 'HelloWorld',
		//   component: HelloWorld
		// },
		{
			path: '/',
			name: 'login',
			component: () => import('@/page/login/index'),
			meta: {
				title: '首页'
			}
		},
    {
    	path: '/login',
    	name: 'login',
    	component: () => import('@/page/login/index'),
    	meta: {
    		title: '首页'
    	}
    },
		{
			path: '/bargain',
			name: 'bargain',
			component: () => import('@/page/bargain/index'),
			meta: {
				title: '合同查询',
				keepAlive: true
			}
		},
		{
			path: '/bargainDetail',
			name: 'bargainDetail',
			component: () => import('@/page/bargain/bargainDetail'),
			meta: {
				title: '还款操作'
			}
		},

    {
    	path: '/bargainShort',
    	name: 'bargainShort',
    	component: () => import('@/page/bargain/bargainShort'),
    	meta: {
    		title: '还款操作'
    	}
    },
		{
			path: '/payResult',
			name: 'payResult',
			component: () => import('@/page/pay/payResult'),

			meta: {
				title: '还款记录'
			}
		},
		{
			path: '/payRecord',
			name: 'payRecord',
			component: () => import('@/page/pay/payRecord'),
			meta: {
				title: '还款记录',
				keepAlive: true
			}
		},
		{
			path: '/goPay',
			name: 'goPay',
			component: () => import('@/page/pay/goPay'),
			meta: {
				title: '还款操作'
			}
		},

		{
			path: '/prodlist',
			name: 'service',
			component: () => import('@/page/prod/list'),
			meta: {
				title: '为你推荐'
			}
		},

		{
			path: '/service',
			name: 'service',
			component: () => import('@/page/service/index'),
			meta: {
				title: '在线客服'
			}
		},
		
		{
			path: '/repayAgreement',
			name: 'repayAgreement',
			component: () => import('@/page/protocol/repayAgreement'),
			meta: {
				title: '还款协议'
			}
		},
		{
			path: '/repayBq',
			name: 'repayBq',
			component: () => import('@/page/protocol/repayBq'),
			meta: {
				title: '还款协议'
			}
		},
		{
			path: '/repayMmt',
			name: 'repayMmt',
			component: () => import('@/page/protocol/repayMmt'),
			meta: {
				title: '还款协议'
			}
		},
		{ //代还保理
			path: '/DHRepayAgreement',
			name: 'DHRepayAgreement',
			component: () => import('@/page/protocol/DHRepayAgreement'),
			meta: {
				title: '还款协议'
			}
		},
		{ //代还佰仟
			path: '/DHRepayBq',
			name: 'DHRepayBq',
			component: () => import('@/page/protocol/DHRepayBq'),
			meta: {
				title: '还款协议'
			}
		},
		{ //代还非保理
			path: '/DHRepayMmt',
			name: 'DHRepayMmt',
			component: () => import('@/page/protocol/DHRepayMmt'),
			meta: {
				title: '还款协议'
			}
		},
		{
			path: '/systemMaintenance',
			name: 'system',
			component: () => import('@/page/systemMaintenance/index')
		},

    {
    	path: '/payGuidel',
    	name: 'payGuidel',
    	component: () => import('@/page/systemMaintenance/payGuidel')
    },
		{
			path: '/cardPay',
			name: 'cardPay',
			component: () => import('@/page/pay/cardPay'),
			meta: {
				title: '银行卡支付',
				// keepAlive: true
			}
		}
	]
});

export default vueRouter;

vueRouter.beforeEach((to, from, next) => {
	/* 路由发生变化修改页面title */
	if (to.meta.title) {
		document.title = to.meta.title;
	}
	if(to.name == 'cardPay' && from.name == 'goPay'){
		to.meta.keepAliveClean = true
	}
	let protocolName = ['repayMmt', 'repayAgreement','repayBq', 'DHRepayAgreement', 'DHRepayBq','DHRepayMmt']
	if(from.name == 'cardPay' && protocolName.includes(to.name)){
		from.meta.keepAliveClean = false
	}
	/* if(!tool.versions.alipay && (to.path == '/bargainDetail' || to.path == '/goPay')){
		next({ path: '/systemMaintenance' });
	} else {
		next();
	} */
	next();
});



// WEBPACK FOOTER //
// ./src/router/index.js